<template>
    <div>
        <!-- Hide the question's ID, useful for debugging. -->
        <!-- <p class="fade-up small my-3">
            {{ question.id }}
        </p> -->
        
        <component
            :is="questionComponent"
            v-model="answer"
            :question="question"
            class="mb-4"
        />

        <div
            v-if="showBack"
            class="d-inline-block fade-up mr-3"
            :style="{transitionDelay: `${baseDelay}s`}"
        >
            <b-btn
                size="sm"
                variant="primary"
                @click="$emit('back')"
            >
                {{ $t('common.buttons.back') }}
            </b-btn>
        </div>

        <div
            class="d-inline-block fade-up"
            :style="{transitionDelay: `${baseDelay + 0.1}s`}"
        >
            <b-btn
                :disabled="!answer"
                size="sm"
                variant="primary"
                @click="$emit('answered', answer)"
            >
                {{ $t('common.buttons.next') }}
            </b-btn>
        </div>
    </div>
</template>

<script>
import MultipleChoices from '@/components/test/question/MultipleChoices';
import StatementsSliders from '@/components/test/question/StatementsSliders';
import SubquestionsChoices from '@/components/test/question/SubquestionsChoices';

export default {
    name: 'Question',
    props: {
        question: {
            type: Object,
            required: true,
        },
        showBack: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            answer: null,
        };
    },
    computed: {
        // Determine question component type based on question content.
        questionComponent() {
            if (this.question.choices) {
                // Basic multiple choices question.
                return MultipleChoices;
            } else if (this.question.subquestions) {
                // Question with multiple choices subquestions (e.g. 7-A).
                return SubquestionsChoices;
            } else if (this.question.statements) {
                // Question with statements sliders (e.g. VVV).
                return StatementsSliders;
            }

            return null;
        },
        baseDelay() {
            return this.showBack ? 0.3 : 0;
        },
    },
    watch: {
        // Clear answer when question changed.
        question: function() {
            this.answer = null;
        },
    },
};
</script>
